import { Router } from 'vue-router';

const globalRouter = { router: null } as { router: null | Router };

export { globalRouter };
